import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--new-create-section"
// 範囲外にあるnewCreateSectionを制御する専用コントローラー
export default class extends Controller {
  connect() {
    // カスタムイベントリスナーを追加
    this.handleToggleEvent = this.handleToggleEvent.bind(this);
    document.addEventListener("newCreateSectionToggle", this.handleToggleEvent);

    // 初期状態は非表示
    this.element.style.display = "none";
  }

  disconnect() {
    // イベントリスナーを削除
    document.removeEventListener(
      "newCreateSectionToggle",
      this.handleToggleEvent
    );
  }

  handleToggleEvent(event) {
    const { shouldShow } = event.detail;

    if (shouldShow) {
      this.element.style.display = "block";
    } else {
      this.element.style.display = "none";
    }
  }
}
